module.exports = "/_next/static/images/apple-touch-icon-a833bf7fe244fd7e2f2ec6f83b3d9520.png";